'use client';

import { ResetButton } from '@components/ResetButton';
import { RevalidateButton } from '@components/RevalidateButton';
import { UiKitButton } from '@components/UiKitButton';
import { useCallback, useState } from 'react';
import styles from './DevPanel.module.css';

type DevPanelProps = {
  missingFields?: string[];
};

export const DevPanel = ({ missingFields = [] }: DevPanelProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handlePanel = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  if (!isOpen)
    return (
      <UiKitButton
        style={{
          position: 'fixed',
          bottom: 16,
          right: 16,
          zIndex: 9999,
        }}
        size="sm"
        onClick={handlePanel}
      >
        Panel {missingFields.length > 0 && `(${missingFields.length})`}
      </UiKitButton>
    );

  return (
    <div className={styles.container}>
      <UiKitButton
        size="sm"
        onClick={handlePanel}
        style={{ position: 'absolute', top: -15, right: 5 }}
      >
        X
      </UiKitButton>
      <ResetButton />
      <RevalidateButton />

      {missingFields.length > 0 && (
        <div
          style={{ marginTop: 16, borderTop: '1px solid #ccc', paddingTop: 8 }}
        >
          <h4
            style={{
              margin: '0 0 8px',
              fontSize: 14,
              fontWeight: 'bold',
              color: 'red',
            }}
          >
            Missing Fields ({missingFields.length})
          </h4>
          <ul
            style={{
              margin: 0,
              paddingLeft: 20,
              maxHeight: 200,
              overflowY: 'auto',
              fontSize: 12,
              color: '#d32f2f',
            }}
          >
            {missingFields.map((field) => (
              <li key={field}>{field}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
